'use client';

import indexationTableFilters from '@/app/dashboard/revenue/indexation/tables/filters';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  IndexationTableConfig,
  type IndexationTable,
} from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const IndexationTableItem: RelationFieldProps<IndexationTable> = {
  nested: getRelationFieldNames(IndexationTableConfig),
  filters: indexationTableFilters,
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <div className='font-medium'>
          {item.useLastKnownValueAsFallback
            ? 'Använd senaste värde om inget nytt angivet'
            : 'Använd ej senaste värde om inget nytt angivet'}
        </div>
        {!isRelationField && <Dot />}
        <span>{item.customId ?? 'Inget ID angett'}</span>
      </div>
    ),
  }),
};
